import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import type StateService from 'garaje/services/state';

import ImporterService from './importer';

// Interface for the CSV data structure
interface DeskCsvData {
  floorName: string;
  neighborhood: string;
  desk: string;
  enabled: string;
  assignedTo: string;
  amenities: string;
}

// Interface for the parsed props returned by _parseProps
interface DeskProps {
  floorName: string;
  neighborhood: string;
  desk: string;
  enabled: string;
  assignedTo: string;
  amenities: string;
}

export default class DesksCsvImporterService extends ImporterService {
  @service declare state: StateService;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/require-await
  handleImport = task(async (data: DeskCsvData): Promise<DeskProps | null> => {
    const props = this._parseProps(data);
    return props;
  });

  private _parseProps(data: DeskCsvData): DeskProps {
    const { floorName, neighborhood, desk, enabled, assignedTo, amenities } = data;
    return {
      floorName,
      neighborhood,
      desk,
      enabled,
      assignedTo,
      amenities,
    };
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    desksCsvImporter: DesksCsvImporterService;
  }
}
